// ─── Loading View ─────────────────────────────────────────────────────────────

export function GitLoadingView() {
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-xl border border-border bg-card">
      {/* Header row */}
      <div className="flex shrink-0 items-stretch border-b border-border">
        {/* Left zone — repo picker */}
        <div className="flex w-72 shrink-0 items-center border-r border-border px-3 py-2">
          <div className="h-9 w-full animate-pulse rounded-lg bg-muted/40" />
        </div>
        {/* Right zone — branch chip + actions */}
        <div className="flex flex-1 items-center gap-3 px-4 py-2">
          <div className="h-4 w-52 animate-pulse rounded bg-muted/30" />
          <div className="ml-auto flex items-center gap-1.5">
            <div className="h-9 w-24 animate-pulse rounded-lg bg-muted/30" />
            <div className="h-9 w-28 animate-pulse rounded-lg bg-muted/30" />
          </div>
        </div>
      </div>

      {/* Split pane */}
      <div className="flex flex-1 min-h-0">
        {/* Left panel */}
        <div className="flex w-72 shrink-0 flex-col border-r border-border">
          {/* Tab strip — matches live tab strip with spring underline */}
          <div className="relative flex border-b border-border">
            {[{ w: "w-16", active: false }, { w: "w-14", active: true }, { w: "w-8", active: false }].map((t, i) => (
              <div key={i} className="flex flex-1 items-center justify-center py-2.5">
                <div className={`h-3 ${t.w} animate-pulse rounded bg-muted/${t.active ? "50" : "30"}`} />
              </div>
            ))}
            {/* Static underline under Commits (center tab) */}
            <div className="absolute bottom-0 left-1/2 h-[2px] w-14 -translate-x-1/2 rounded-full bg-primary/40" />
          </div>
          {/* List rows — structured like real commit/branch rows */}
          <div className="flex-1">
            {Array.from({ length: 10 }).map((_, i) => (
              <div
                key={i}
                className="border-b border-border/50 px-3 py-3"
                style={{ opacity: Math.max(0.15, 1 - i * 0.09) }}
              >
                <div className={`mb-2 h-3 animate-pulse rounded bg-muted/40 ${["w-4/5","w-3/4","w-[85%]","w-2/3","w-4/5","w-3/5","w-3/4","w-[90%]","w-2/3","w-3/4"][i]}`} />
                <div className="flex items-center gap-1.5">
                  <div className="h-2 w-10 animate-pulse rounded bg-muted/25" />
                  <div className="h-1.5 w-1 rounded-full bg-muted/20" />
                  <div className="h-2 w-14 animate-pulse rounded bg-muted/25" />
                  <div className="h-1.5 w-1 rounded-full bg-muted/20" />
                  <div className="h-2 w-16 animate-pulse rounded bg-muted/25" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right panel */}
        <div className="flex flex-1 flex-col items-center justify-center gap-4 p-10">
          <div className="grid w-full max-w-sm grid-cols-2 gap-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-16 animate-pulse rounded-lg border border-border/60 bg-muted/20" />
            ))}
          </div>
          <div className="h-3 w-48 animate-pulse rounded bg-muted/30" />
        </div>
      </div>
    </div>
  );
}
